import { render, staticRenderFns } from "./housing.vue?vue&type=template&id=638be934&scoped=true"
import script from "./housing.vue?vue&type=script&lang=js"
export * from "./housing.vue?vue&type=script&lang=js"
import style0 from "./housing.vue?vue&type=style&index=0&id=638be934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638be934",
  null
  
)

export default component.exports